import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../auth/AuthContext";
import { ShieldCheck } from "lucide-react";
import { formatNumber, formatUsd } from "../lib/currencyDisplay";

export default function PolicyCard({ bookingId }) {
  const [policy, setPolicy] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!bookingId) return;
    let alive = true;
    (async () => {
      try {
        const r = await axios.get(`${API}/policies/booking/${bookingId}`, { withCredentials: true });
        if (alive) setPolicy(r.data);
      } catch (e) {
        if (alive) setErr(true);
      }
    })();
    return () => { alive = false; };
  }, [bookingId]);

  if (err || !policy) return null;

  return (
    <div className="zc-card p-5" data-testid="policy-card">
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 rounded-full grid place-items-center bg-[var(--zc-accent-soft)] text-[var(--zc-accent)]">
          <ShieldCheck size={18} />
        </span>
        <div className="flex-1 min-w-0">
          <div className="eyebrow">Per-trip insurance</div>
          <div className="zc-title text-lg leading-tight mt-0.5">{policy.provider}</div>
        </div>
        <span className="zc-badge text-[var(--zc-success)] font-semibold">{policy.status}</span>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mt-4 pt-4 border-t border-[var(--zc-border)]">
        <div>
          <div className="eyebrow">Policy #</div>
          <div className="font-mono text-xs mt-1" data-testid="policy-number">{policy.policy_number}</div>
        </div>
        <div>
          <div className="eyebrow">Premium</div>
          <div className="font-semibold text-sm mt-1">${formatUsd(policy.premium)}</div>
        </div>
        <div>
          <div className="eyebrow">Coverage</div>
          <div className="font-semibold text-sm mt-1">${Number(policy.coverage_amount).toLocaleString()}</div>
        </div>
        <div>
          <div className="eyebrow">Deductible</div>
          <div className="font-semibold text-sm mt-1">${formatNumber(policy.deductible, 0)}</div>
        </div>
      </div>
      <div className="zc-hint mt-3">
        Per-trip protection auto-attached at booking. Coverage is active from pick-up to return.
      </div>
    </div>
  );
}
